//引入、配置路由的相关信息
import Vue from 'vue'
import VueRouter from 'vue-router'
//1.Vue.use安装插件
Vue.use(VueRouter)

const Home = () => import('@/views/Home');
const Login = () => import('@/views/Login');



const routes =[
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/home",
        name: "Home",
        component: Home,
    }
    ,{
        path: "/login",
        name: "Login",
        component: Login,
    }
]
//2.创建路由对象
const router = new VueRouter({
    // mode: "history",
    mode: "hash",
    base: process.env.BASE_URL,
    //配置路由与组件的关系
    routes,

})
//3.将router对象导出
export default router

